import React, { useMemo } from 'react';
import classnames from 'classnames';
// import InlineWatermark from '@intelligence/components/InlineWatermark';
import ComposableImg from '@gp/components/ComposableImg';
// import { captureExpendClassName } from '@intelligence/utils/captureUtils';
// import useDPSReportImgsLoadingState from '../../_hooks/useDPSReportImgsLoadingState';

import type { IBaseProps } from '@home/types/common';
import type { IDPSReportVO } from '@gp/types/dpsReport/common';

interface IReviewReportProps extends IBaseProps {
  node?: React.RefObject<HTMLDivElement>;
  subTitle?: string;
  report?: IDPSReportVO | null;
}

const ReviewReport: React.FC<IReviewReportProps> = (props) => {
  const { style, className, node, subTitle, report } = props;

  const currentReportImgs = useMemo<string[]>(() => report?.images || [], [report]);

  // const { isLoading: isReportImgsLoading, onImgLoad, onImgError } = useDPSReportImgsLoadingState(currentReportImgs);

  return (
    <div style={style} className={classnames('dbg-dps-report__review-image-report', className)}>
      <div className="dbg-dps-report__sub-title">{subTitle}</div>
      <div ref={node} className="dbg-dps-report__composable-img-container">
        {/* <ComposableImg imgList={currentReportImgs} onLoad={onImgLoad} onError={onImgError} /> */}
        <ComposableImg imgList={currentReportImgs} onLoad={() => {}} onError={() => {}} />
        {/* <InlineWatermark className={classnames('dbg-dps-report__watermark', captureExpendClassName)} /> */}
      </div>
    </div>
  );
};

export default ReviewReport;
